export default {
  getOrders: (state) => {
    const data = state.orders || [];
    return data;
  },
};
